import { CommonAssayResponse } from '@/api/services/common/assay/common-assay.dto'
import { EnumResponse } from '@/api/services/common.dto'
import { Nullable } from '@/shared/types/app.types'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { ShipmentRuleAssayResponse } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-assay/shipment-rule-assay.dto'
import { manualShipmentRuleAssayService } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/manual-shipment-rule-assay/manual-shipment-rule-assay.service'
import { shipmentRuleAssayService } from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-assay/shipment-rule-assay.service'

export const columnsDefShipmentRulesModalAssayRelationships =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.subportionGrid.assay'),
            field: 'assay.name',
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('laboratory.grid.columns.status'),
            field: 'subportionInternalStatus',
            filter: false,
            flex: 1,
            cellRenderer: ({ value }: ICellRendererParams) => value?.translatedName
        }
    ]

export interface ShipmentRulesModalAssayRelationshipsState extends CrudModelPaginatorLaboratory<ShipmentRuleAssayResponse>{
    assay: Nullable<CommonAssayResponse>
    assayState: Nullable<EnumResponse>
    comboOptions: {
        assays: CommonAssayResponse[]
        assayStates: EnumResponse[]
    }
}
export const initialShipmentRulesModalAssayRelationshipsState =
    (isManual: boolean, shipmentRuleId: number): ShipmentRulesModalAssayRelationshipsState => {
        const datasourceService = isManual ? manualShipmentRuleAssayService : shipmentRuleAssayService
        return {
            ...initialCrudModelBaseState(),
            columnsDef: columnsDefShipmentRulesModalAssayRelationships(),
            datasource: new PaginatorLaboratoryDatasource(datasourceService, shipmentRuleId),
            assay: null,
            assayState: null,
            comboOptions: {
                assays: [],
                assayStates: []
            }
        }
    }
